import React from 'react';
import Api from '../../../services/Api';
import useNFTCollectionList from './useNFTCollectionList';

const useGetNFTCollection = (contractAddress: string) => {

    const [nftCollection, setNftCollection] = React.useState<any>(null);

    const nftCollectionList = useNFTCollectionList();

    React.useEffect(() => {
        let isCancelled = false;
        //look to cache for nft collection
        setNftCollection(nftCollectionList.find(nft => nft.tokenAddress.toLowerCase() === contractAddress.toLowerCase()));
        // const cachedNftCollection = localStorage.getItem(`${contractAddress}_nftCollection`);
        // if (cachedNftCollection) {
        //     setNftCollection(JSON.parse(cachedNftCollection));
        // } else {
        //     Api.get('https://api.yetiswap.app/collection/getVerified/' + contractAddress).then((res: any[]) => {
        //         if (!isCancelled) {
        //             if (res.length > 0) {
        //                 setNftCollection(res[0])
        //                 localStorage.setItem(`${contractAddress}_nftCollection`, JSON.stringify(res[0]));
        //             } else {
        //                 setNftCollection(null)
        //             }
        //         }
        //     });
        // }
        return () => {
            isCancelled = true;
        }
    }, [contractAddress, nftCollectionList]);

    return nftCollection;
};
export default useGetNFTCollection;
